import React from 'react'
import styled from '@emotion/styled'
import { Box } from '@mui/system'
import { CalendarTimetable } from './components/CalendarTimetable'

const TimetablePage = () => {
    return (
        <Wrapper>
            <Content>
                <Box
                    sx={{
                        display: 'flex',
                        '@media screen and (max-width: 500px)': {
                            flexDirection: 'column',
                        },
                    }}
                >
                    <CalendarTimetable />
                </Box>
            </Content>
        </Wrapper>
    )
}

export default TimetablePage

const Wrapper = styled.div`
    margin: 10px;
    border-radius: 16px;
`

const Content = styled.div`
    background-color: #fff;
    border-radius: 16px;
    padding: 20px 40px;
    min-height: 80vh;

    @media screen and (max-width: 500px) {
        padding: 24px 16px;
    }
`
